module.exports = __webpack_public_path__ + "img/book-white.12447e1a.svg";